<template>
  <v-app id="inspire">
    <!-- <v-parallax
      style="height: 100vh;"
      dark
      height="100%"
      jumbotron
      :src="require('@/assets/img/login-nominus.jpg')"
    > -->
    <v-main align="center" justify="center">
      <v-container fill-height fluid>
        <template>
          <v-card
            class="mx-auto"
            max-width="344"
            color="rgb(255, 255, 255, 0.9)"
          >
            <v-card-title class="justify-center">
              <p style="font-size: 20px;" class="text--primary text-center">
                DINO TOYS v1.0.0
              </p>
            </v-card-title>
            <v-card-title class="justify-center mt-n5">
              <img :src="require('@/assets/logo.png')" alt="Dino Toys" width="200">
            </v-card-title>
            <v-card-text>
              <div class="text--primary text-center">
                <p style="color: #015d01">
                  Bienvenido al administrador de Dino Toys, por favor iniciar sesion.
                </p>
              </div>
            </v-card-text>
            <v-card-text class="mt-n5">
              <template>
                <v-form
                  ref="form"
                  v-model="form"
                >
                  <v-text-field
                    v-model="email"
                    filled
                    :rules="[rules.email]"
                    color="primary"
                    label="Usuario"
                    type="email"
                    outlined
                    dense
                    @keyup.enter="login"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    filled
                    :rules="[rules.required]"
                    color="primary"
                    label="Passowd"
                    type="password"
                    outlined
                    dense
                    @keyup.enter="login"
                  ></v-text-field>
                </v-form>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-btn
                :disabled="!form"
                @click="login()"
                color="primary"
                block
                depressed
                class="mt-n2"
              >
                Iniciar Sesión
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-container>
    </v-main>
    <!-- </v-parallax> -->
  </v-app>
</template>
<script>
  import axios from 'axios'

  var urlGlobal = process.env.DINO.ENDPOINT + process.env.DINO.PATH.LOGIN;
  var authorization = process.env.AUTHORIZATION;
  export default {
    name: 'LoginView',
    data () {
      return {
        email: '',
        password: '',
        form: false,
        rules: {
          email: v => /.+@.+\..+/.test(v) || 'Por favor ingresar un correo válido',
          length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
          required: v => !!v || 'Por favor completar este campo',
        },

        items: [
          { text: 'Facebook', icon: 'mdi-facebook', color: 'blue darken-2' },
          { text: 'Google', icon: 'mdi-google', color: 'red darken-2' },
        ],
        typeSocial: null,
        tokenId: null,
        objLogin: {
          correo: null
        },
        usuario: {},
        group: null,
        infoTrabajador: [],
        contratoSelected: null,
        iContrato: null
      }
    },
    mounted: function () {
      console.log('%cSí, porque toma la identidad de otra persona con el fin de perjudicarle material o moralmente, por lo que está tipificado en el Artículo 9 de la Ley Nº 30096 o Ley de delitos informáticos. La suplantación de identidad se sanciona con pena privativa de libertad no menor de tres ni mayor de cinco años.', 'background: #ffcc00; color: #000000; font-size: 13px;');
      console.log('%cYes, because it assumes the identity of another person in order to harm them materially or morally, for which it is typified in Article 9 of Law No. 30096 or Computer Crime Law. Identity theft is punishable by imprisonment for not less than three nor more than five years.', 'background: #ffcc00; color: #000000; font-size: 13px;');
    },
    methods: {
      setUsuario: function (givenName, familyName, picture, email) {
        this.usuario.givenName = givenName;
        this.usuario.familyName = familyName
        this.usuario.picture = picture;
        this.usuario.correo = email;
      },

      login: function () {
        let request = {
          email: this.email,
          password: this.password
        };

        axios.post(urlGlobal, request)
        .then(response => {
          if (response.data.success) {
            localStorage.clear();
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('menus', JSON.stringify(response.data.menus));
            localStorage.setItem('authorization', response.data.authorization);
            this.redirect();
          } else {
            alert(response.data.message);
            this.logout();
          }
        })
        .catch((err) => {
          alert(err.message);
          console.log(err.response);
          this.logout();
        });
      },

      redirect: function() {
        this.$router.push({ name:'Inicio' }).catch(err => {});
      }
    }
  }
</script>
<style scoped>
  .tile {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue